import React from 'react';

import OverzichtMeldingen from '../../components/systemNotices/OverzichtMeldingen';

const PageMeldingen: React.FC = () => {
  return (
    <>
      <header className="app-header">
        <h1>Updates infraplannen.nl</h1>
        <p className="header-sub-title center">
          Een overzicht van alle actuele updates omtrent infraplannen.nl, klik op een titel om de updates te lezen.
        </p>
      </header>

      <div className="content">
        <OverzichtMeldingen />
      </div>
    </>
  );
};

export default PageMeldingen;
